module.exports = __webpack_public_path__ + "img/sample.156e3c95.svg";